import { NgIf } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DxNumberBoxModule, DxValidatorModule } from 'devextreme-angular';
import { DxiButtonModule } from 'devextreme-angular/ui/nested';
import { FormValidationComponent } from '../form-validation/form-validation.component';

@Component({
    selector: 'form-numberbox',
    templateUrl: './form-numberbox.component.html',
    styleUrls: ['form-numberbox.component.scss'],
    imports: [DxNumberBoxModule, DxValidatorModule, NgIf, DxiButtonModule]
})
export class FormNumberboxComponent extends FormValidationComponent {
  @Input() isEditing = false;
  @Input() text: string;
  @Input() label = '';
  @Input() icon: string = null;
  @Input() value!: number;

  @Output() valueChange = new EventEmitter<number>();
  valueChanged(e) {
    this.valueChange.emit(e.value);
  }
}
